<template>
  <el-tabs
      :value="activeTab ||(adStore.SB.campaign.targetingType == 1 ? 'adProductTarget' : 'adKeyword')"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adKeyword" lazy v-if="adStore.SB.campaign.targetingType != 1">
      <template #label>关键词<gj-badge class="ad-badge" type="num" :value="cornerMarker.countKeywords || 0"></gj-badge></template>
      <app-sb-ad-keyword
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          table-name="sbAdCampaignKeyword"
      ></app-sb-ad-keyword>
    </el-tab-pane>
    <el-tab-pane name="adNegKeyword" lazy v-if="adStore.SB.campaign.targetingType != 1">
      <template #label>否定关键词<gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeKeywords || 0"></gj-badge></template>
      <app-sb-ad-neg-keyword
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          table-name="sbAdCampaignNegKeyword"
      ></app-sb-ad-neg-keyword>
    </el-tab-pane>
    <el-tab-pane name="adProductTarget" lazy v-if="adStore.SB.campaign.targetingType != 0">
      <template #label>商品投放<gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargeting || 0"></gj-badge></template>
      <app-sb-ad-product-target
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          table-name="sbAdProductTarget"
      ></app-sb-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" lazy v-if="adStore.SB.campaign.targetingType != 0">
      <template #label>否定商品投放<gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeTargeting || 0"></gj-badge></template>
      <app-sb-ad-neg-target
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          table-name="sbAdNegTarget"
      ></app-sb-ad-neg-target>
    </el-tab-pane>
    <el-tab-pane name="adSearchWord" lazy>
      <template #label>用户搜索词</template>
      <app-sb-ad-search-keyword
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          table-name="sbAdSearchWord"
      ></app-sb-ad-search-keyword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import { adStore } from "modules/ad/common/store";
  import AppSbAdKeyword from "../components/ad-keyword/ad-keyword";
  import AppSbAdNegKeyword from "../components/ad-neg-keyword/ad-neg-keyword";
  import {AdCampaignEnum} from "../../common/enum";
  import AppSbAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSbAdProductTarget from "../components/ad-product-target/ad-product-target";
  import AppSbAdSearchKeyword from "../components/ad-search-word/ad-search-word";
  import {inCampaignMixin, initDateMixin, inMarketMixin, tabResizeMixin, inPortfolioMixin} from "../../common/mixin";
  
  export default {
    name: "app-sb-ad-campaign-manager",
    components: {AppSbAdNegKeyword, AppSbAdKeyword, AppSbAdNegTarget, AppSbAdProductTarget, AppSbAdSearchKeyword},
    mixins: [inMarketMixin, inCampaignMixin, tabResizeMixin, initDateMixin, inPortfolioMixin],
    inject: ['cornerMarkerMap'],
    props: {
      activeTab: {
        default: 'adKeyword',
      }
    },
    created() {
    // adStore.SB.campaign.targetingType
    },
    data() {
      return {
        adStore,
        AdCampaignEnum: AdCampaignEnum,
        // campaign: {}
      }
    },
    methods: {
      campaignChange(campaignId) {
        // getSpAdCampaign(campaignId)
        //   .then(() => {
        //     this.campaign = {targetingType: AdCampaignEnum.SB.targetingType.AUTO};
        //   })
        //   .complete(() => {
        //     debugger
        //   });
      }
    },
    computed: {
      cornerMarker() {
        return this.cornerMarkerMap()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  // /deep/.el-tabs__item {
  //   font-size: 12px;
  //   height: 36px;
  //   line-height: 36px;
  // }
  .ad-badge{
    margin-left: 4px;
    /deep/ .el-badge__content{
      font-weight: 600;
      font-family: PingFangSC-Semibold;
    }
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
